import * as React from 'react'
import { observer } from 'mobx-react'
import styles from './OpportunityItem.sass'
import cx from 'classnames'
import Link from 'components/Link'
import Icon from '../../../components/Icon'

interface OpportunityItemProps {
  children?: React.ReactNode
  disabled: boolean
  selected: boolean
  onSelect: () => unknown
  'data-test'?: string
}

export default observer(function OpportunityItem({
  children,
  disabled,
  selected,
  onSelect,
  'data-test': dataTest,
}: OpportunityItemProps) {
  return (
    <Link
      className={cx(
        styles.root,
        disabled && styles.disabled,
        selected && styles.selected,
      )}
      onClick={() => {
        if (!disabled) {
          onSelect()
        }
      }}
      data-test={dataTest}
    >
      {children}
      <div className={styles.shadow} />
    </Link>
  )
})

interface OpportunityItemInfoProps {
  children?: React.ReactNode
}

export const OpportunityItemAvatarInfo = function OpportunityItemAvatarAndInfo({
  children,
}: OpportunityItemInfoProps) {
  return <div className={styles.avatarAndInfo}>{children}</div>
}

interface OpportunityItemAvatarProps {
  disabled: boolean
  avatar: React.ReactNode
  secondaryAvatar?: React.ReactNode
}
export const OpportunityItemAvatar = observer(function OpportunityAvatar({
  disabled,
  avatar,
  secondaryAvatar,
}: OpportunityItemAvatarProps) {
  return (
    <div className={cx(styles.avatarContainer, disabled && styles.disabled)}>
      {avatar}
      {secondaryAvatar && (
        <div className={styles.secondaryAvatar}>{secondaryAvatar}</div>
      )}
    </div>
  )
})

interface OpportunityItemInfoProps {
  children?: React.ReactNode
}

export const OpportunityItemInfo = observer(function OpportunityItemInfo({
  children,
}: OpportunityItemInfoProps) {
  return (
    <div className={styles.info}>
      <div className={styles.primaryInfo}>{children}</div>
    </div>
  )
})

interface OpportunityItemTitleProps {
  title: string
  secondaryTitle?: string
  subtitle?: string
  disabled: boolean
}

export const OpportunityItemTitle = observer(function OpportunityItemTitle({
  title,
  secondaryTitle,
  disabled,
}: OpportunityItemTitleProps) {
  return (
    <p className={styles.title}>
      {title}
      {secondaryTitle && (
        <span>
          <span className={styles.titleSeparator}> • </span>
          <span
            className={cx(styles.secondaryTitle, disabled && styles.disabled)}
          >
            {secondaryTitle}
          </span>
        </span>
      )}
    </p>
  )
})

interface OpportunityItemSubtitleProps {
  children?: React.ReactNode
}

export const OpportunityItemSubtitle = observer(
  function OpportunityItemSubtitle({ children }: OpportunityItemSubtitleProps) {
    return <p className={styles.subtitle}>{children}</p>
  },
)

export function ForwardIcon({
  disabled = false,
  selectColor = 'blue',
}: ForwardIconProps) {
  return (
    <div
      className={cx(
        styles.forwardIconContainer,
        selectColor && styles[selectColor],
      )}
    >
      {!disabled && <Icon name="arrow" />}
    </div>
  )
}

interface ForwardIconProps {
  disabled: boolean
  selectColor?: 'blue' | 'green' | 'red'
}
